import Price from "@/app/components/lib/Price";

interface Props {
  price: number;
  priceWithoutDiscount: number;
  sameLine?: boolean;
}

const ProductPrice: React.FC<Props> = ({
  priceWithoutDiscount,
  price,
  sameLine,
}) => {
  return (
    <Price
      price={{ value: price, className: "product-price" }}
      priceWithoutDiscount={{
        value: priceWithoutDiscount,
        className: "product-without-discount-price",
      }}
      currencySymboleClassName="product-currency"
      sameLine={sameLine}
      roundPrice
    />
  );
};

export default ProductPrice;
